import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';
import BasicModal from 'components/common/BasicModal';
import PrimaryButton from '../Common/Buttons/PrimaryButton';
import SecondaryButton from '../Common/Buttons/SecondaryButton';
import {
	WEIGHTING_ALERTS_DISCLAIMER,
	WEIGHTING_DISCLAIMER,
} from './healthScoreWeightingConstants';

const HealthScoreWeightingConfirmModal = ({
	open,
	onCancel,
	onConfirm,
	saving,
}) => (
	<BasicModal
		open={open}
		onClose={onCancel}
		title='Confirm weighting changes'
		actions={
			<>
				<SecondaryButton label='Cancel' onClick={onCancel} disabled={saving} />

				<PrimaryButton
					label='Confirm and Save'
					onClick={onConfirm}
					loading={saving}
				/>
			</>
		}
	>
		<Stack spacing={2}>
			<Typography sx={{ fontSize: '13px' }}>{WEIGHTING_DISCLAIMER}</Typography>

			<Typography sx={{ fontSize: '13px' }}>
				{WEIGHTING_ALERTS_DISCLAIMER}
			</Typography>
		</Stack>
	</BasicModal>
);

HealthScoreWeightingConfirmModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	saving: PropTypes.bool,
};

export default HealthScoreWeightingConfirmModal;
